import { pxToChars } from "../../../utils/excelToFortuneSheet";
import { COLUMN_TYPE_TO_WIDTH, DEFAULT_NOTES_COLUMN_WIDTH } from "../constants";
import type { PrintoutColumn } from "../types";

interface ComputeColumnWidthsArgs {
	enabledColumns: PrintoutColumn[];
	printNotes: boolean;
	columnWidthOverrides: Record<string, number> | undefined;
}

/**
 * Per-column widths for a worksheet (mapping §8.3). Preview overrides arrive in pixels and are
 * converted with `pxToChars` — the exact inverse of the conversion the preview was built with, so a
 * dragged column comes back the width it was dragged to.
 *
 * With `printNotes` on and no `notes` column already in the list, a trailing one is added.
 */
export const computeColumnWidths = ({ enabledColumns, printNotes, columnWidthOverrides }: ComputeColumnWidthsArgs): { width: number }[] => {
	const widths = enabledColumns.map<{ width: number }>((col, index) => {
		const overridePx = columnWidthOverrides?.[String(index)];
		return { width: overridePx ? pxToChars(overridePx) : COLUMN_TYPE_TO_WIDTH[col.type] };
	});
	if (printNotes) {
		const hasNotesColumn = enabledColumns.some((col) => col.type === "notes");
		if (!hasNotesColumn) {
			const notesIndex = widths.length;
			const overridePx = columnWidthOverrides?.[String(notesIndex)];
			widths.push({ width: overridePx ? pxToChars(overridePx) : DEFAULT_NOTES_COLUMN_WIDTH });
		}
	}
	return widths;
};
